import React, { memo } from "react";
import ShopifyModal from "../ShopifyModal";

import intl from "../../i18n/intl";

const ArchiveOrderModal = memo(
  ({ setDlocalTip,dlocalTip,getOrderListData}) => {
    return (
      <div>
        <ShopifyModal id="shared-dlocal-pay-tip-modal"
          open={dlocalTip}
          onClose={() => {
            setDlocalTip(false);
            getOrderListData();
          }}
          heading={intl.get("Payment Confirm")}
          primaryAction={{
              content: intl.get("Okay"),
              onAction: () => {
                setDlocalTip(false);
                getOrderListData();
              },
            }}
        >
          {`Please ensure that you have completed the payment for your order and confirmed that the Dropshipman order status has changed to "Paid" before the order can be fulfilled.`}
          </ShopifyModal>
      </div>
    );
  }
);

export default ArchiveOrderModal;
